import { useAccountInfo } from '@/hooks/query/account';
import { Market, SportMatchModel } from '@nf/types/odds'
import { useEffect, useState } from 'react';
import { getTimeMachineOdds } from '@nf/odds/odds-api/match';
import { useParams } from 'next/navigation';
import { useInterval } from '@nf/utils-common/hooks';
import { Clock } from './time-machine-contents/time-machine-clock';
import { useTranslations } from 'next-intl';
import { TimeMachineOddsButton } from './time-machine-contents/time-machine-odds-button';
import { LoadingIcon } from '@/components/icons/svg-icons';


export const TimeMachineContent = ({ matchModel, isOpen }: { matchModel: SportMatchModel, isOpen: boolean }) => {
	const { user } = useAccountInfo();
	const t = useTranslations('General');
	const [oddsData, setOddsData] = useState<Market[]>([]);
	const [isLoading, setIsLoaing] = useState(true);
	const params = useParams();
	const syncPeriod = 6 * 1000;

	useInterval(
		async () => {
			try {
				const timeMachineOdds = await getTimeMachineOdds({
					sport: matchModel.GameID ?? 0,
					market: params.market as string ?? 'l',
					betTypeClass: 'tm',
					matchId: matchModel.MatchId,
					gameType: 0
				});
				setOddsData(timeMachineOdds);
			} catch (error) {
				console.error(error);
			}
		},
		isOpen ? syncPeriod : null,
		{ immediate: true }
	);

	useEffect(() => {
		if (oddsData.length > 0 && isLoading) {
			setIsLoaing(false);
		}
	}, [oddsData]);

	if (!isOpen) return null;

	return isLoading ? (
		<div className="loading-circle">
			<LoadingIcon />
		</div>
	) : (
		<>
			<div className="time-machine__content">
				<div className="tm-bettype">
					<div className="tm-text-title">{t('lbl_hdp')}</div>
					{
						!user?.TMHDP ?
							<div className="tm-text">{t('lbl_Coming_Soon')}</div>
							:
							<TimeMachineOddsButton
								matchModel={matchModel}
								oddsData={oddsData}
								betTypeId={229}
							/>
					}
				</div>
				<Clock />
				<div className="tm-bettype">
					<div className="tm-text-title">{t('lbl_o_u')}</div>
					<TimeMachineOddsButton
						matchModel={matchModel}
						oddsData={oddsData}
						betTypeId={228}
					/>
				</div>
			</div>
		</>
	)
}